import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ToastProvider } from './components/shared/Toast';
import AppShell from './components/layout/AppShell';
import Forside from './pages/Forside';
import Kalender from './pages/Kalender';
import TilfoejDag from './pages/TilfoejDag';
import Notifikationer from './pages/Notifikationer';
import OmSiden from './pages/OmSiden';
import './index.scss';

function App() {
  return (
    <Router>
      <ToastProvider>
        <AppShell>
          <Routes>
            <Route path="/" element={<Forside />} />
            <Route path="/kalender" element={<Kalender />} />
            <Route path="/tilfoej" element={<TilfoejDag />} />
            <Route path="/notifikationer" element={<Notifikationer />} />
            <Route path="/om" element={<OmSiden />} />
          </Routes>
        </AppShell>
      </ToastProvider>
    </Router>
  );
}

export default App;
